document.addEventListener('DOMContentLoaded', () => {
  const SELECTORS = {
    widget: '[data-chat-widget]',
    chatWindow: '#chat-window',
    launcher: '#gorgias-chat-container #chat-button, #chat-button',
    iframeLauncherButton: 'button, [role="button"]',
  }

  const CLASSES = {
    appear: 'appear',
    close: 'chat-widget--close',
  }

  const chatWidget = document.querySelector(SELECTORS.widget)
  if (!chatWidget) return

  function isChatOpen () {
    const chatBox = document.querySelector(SELECTORS.chatWindow)
    return !!(chatBox && chatBox.offsetWidth > 0)
  }

  function getLauncherEl () {
    return document.querySelector(SELECTORS.launcher)
  }

  function updateWidgetState () {
    if (isChatOpen()) {
      chatWidget.classList.add(CLASSES.close)
    } else {
      chatWidget.classList.remove(CLASSES.close)
    }
  }

  function showWidgetIfLauncherExists () {
    if (getLauncherEl()) {
      chatWidget.classList.add(CLASSES.appear)
      updateWidgetState()
      return true
    }
    return false
  }

  function triggerNativeLauncher () {
    const launcherEl = getLauncherEl()
    if (!launcherEl) return false

    if (launcherEl.tagName === 'IFRAME') {
      const iframeDocument = launcherEl.contentDocument || launcherEl.contentWindow?.document
      const iframeButton = iframeDocument?.querySelector(SELECTORS.iframeLauncherButton)
      if (iframeButton) {
        iframeButton.click()
        return true
      }
    }

    launcherEl.click()
    return true
  }

  let stateSyncTimer = null
  function scheduleStateSync () {
    if (stateSyncTimer) return
    stateSyncTimer = window.setTimeout(() => {
      updateWidgetState()
      stateSyncTimer = null
    }, 80)
  }

  chatWidget.addEventListener('click', () => {
    triggerNativeLauncher()
    window.setTimeout(updateWidgetState, 100)
  })

  if (showWidgetIfLauncherExists()) return

  const observer = new MutationObserver(() => {
    if (showWidgetIfLauncherExists()) {
      observer.disconnect()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })

  // Keep state synced when chat is closed/opened from inside the widget UI.
  const stateObserver = new MutationObserver(() => {
    scheduleStateSync()
  })

  stateObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
  })
})
